import React, { useEffect, useState } from "react";
import "./../Customer.css";
import { Avatar, Col, Tag, Typography } from "antd";
import CustomerHeader from "./MOBcreditCustomerHeader";
// import {
//   // PlusOutlined,
//   DashOutlined,
// } from "@ant-design/icons";
import CustomTableWithPagination from "../../../components/CustomTableWithPagination/CustomTableWithPagination";
import { ReactComponent as DefaultIcon } from "../../../assets/icons/default.svg";
// import {
//   Link,
//   //  useNavigate
// } from "react-router-dom";

import {
  
 useLazyGetMOBCreditCustomersQuery
  
} from "../../../apis/customer";

// import { baseQuery } from "../../apis/baseQuery";
import { baseUrl } from "../../../commonUtils/commonUtils";
// eslint-disable-next-line
import { dateFormat } from "../../../commonFuntions/CommonUtilFunctions";
import TableSkeleton from "../../../components/skeleton/TableSkeleton";
// import ManageDeleteModal from "../../../components/Modal/DeleteModal/ManageDeleteModal/ManageDeleteModal";
// import {
//   showErrorToast,
//   showSuccessToast,
// } from "../../../NotificationToast/NotificationToast";
import NoDataFound from "../../../components/EmptyTable/NoDataFound";
import { useNavigate } from "react-router-dom";
const { Text } = Typography;


const MOBcreditCustomer = () => {
  const navigate = useNavigate();

  // const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  // const [selectedRowData, setSelectedRowData] = useState({});
  const [searchedValue, setSearchedValue] = useState({});
  const [currentPage, setCurrentPage] = useState(1);



  const [
    getAllCustomersApi,
    {
      data: tableData,
      //  isLoading,
      isFetching,
    },
  ] = useLazyGetMOBCreditCustomersQuery();


  


  
  const handleAddCustomer = () => {
    navigate("/admin/customer/create-mob-credit-direct/");
    
  };

  // const navigate = useNavigate();
  // const handleUserDetailsNavigation = (record) => {
  //   navigate(`/admin/customer/customerDetails/${record?.phone_number}`, {
  //     state: { id: `/admin/customer` },
  //   });
  // };
  // const handleDeleteModalOpen = (data) => {
  //   setSelectedRowData(data);
  //   setIsDeleteModalOpen(true);
  // };
  // const handleDeleteModalCancel = () => {
  //   setIsDeleteModalOpen(false);
  // };
  useEffect(() => {
    getAllCustomersApi();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleSearchedValue = (params) => {
    setSearchedValue(params);
    setCurrentPage(1);
  };

  const handlePageChange = async (currPage) => {
    const params = {
      page: currPage,
      ...(searchedValue && { search: searchedValue?.search }),
    };
    setCurrentPage(currPage);
    await getAllCustomersApi(params);
  };

  const columns = [
    // {
    //   // title: (
    //   //   <PlusOutlined
    //   //     style={{
    //   //       backgroundColor: "#fff",
    //   //       borderRadius: "50%",
    //   //       padding: "3px",
    //   //     }}
    //   //   />
    //   // ),
    //   key: "icon",
    //   dataIndex: "icon",
    //   fixed: "left",
    //   width: "50px",
    //   render: (params, record) => {
    //     return (
    //       <>
    //         <Dropdown
    //           overlay={
    //             <Menu>
    //               <>
    //                 <Menu.Item
    //                   // onClick={() => onEdit(record)}
    //                   style={{ padding: "7px 12px" }}
    //                 >
    //                   <Col className="container-list">
    //                     <Text className="select-text">Edit</Text>
    //                   </Col>
    //                 </Menu.Item>
    //                 <Menu.Item
    //                   // onClick={() => handleDeleteModalOpen(record)}
    //                   style={{ padding: "7px 12px" }}
    //                 >
    //                   <Col className="container-list">
    //                     <Text className="select-text">Delete</Text>
    //                   </Col>
    //                 </Menu.Item>
    //               </>
    //             </Menu>
    //           }
    //           trigger={"click"}
    //         >
    //           <DashOutlined
    //           //   onClick={() => _onRowClick(record)}
    //           />
    //         </Dropdown>
    //       </>
    //     );
    //   },
    //   // height: "60px",
    // },
    {
      title: "Name",
      dataIndex: "profile_image",
      key: "profile_image",
      fixed: "left",
      width: "300px",
      render: (params, record) => {
        return (
          <>
            <Col
              style={{
                display: "flex",
                gap: "20px",
                alignItems: "center",
                paddingLeft: record.parentKey ? "60px" : "0px",
              }}
            >
              <Col>
                <Avatar
                  style={{
                    width: "48px",
                    height: "48px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "#f1f1f2",
                  }}
                  shape="square"
                  src={`${baseUrl}${record.profile_image}`}
                  alt="Avatar"
                  icon={<DefaultIcon width={20} height={20} />}
                />
              </Col>
              {/* <Link
                to={`/admin/customer/customerDetails/${record?.phone_number}`}
                target="_blank"
                // onClick={() => handleUserDetailsNavigation(record)}
                style={{ fontWeight: 500, color: "#2973f0", cursor: "pointer" }}
              > */}
                {record.name}
              {/* </Link> */}
            </Col>
          </>
        );
      },
    },
    {
      title: "Business mobile(For OTP)",
      dataIndex: "business_mobile",
      key: "business_mobile",
      width: "150px",
      render: (params, record) => {
        return (
          // <Link
          //   // onClick={() => handleUserDetailsNavigation(record)}
          //   to={`/admin/customer/customerDetails/${record?.phone_number}`}
          //   target="_blank"
          //   style={{ fontWeight: 500, color: "#2973f0", cursor: "pointer" }}
          // >
            {params}
          // </Link>
        );
      },
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      width: "300px",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: "150px",
      render: (params, record) => {
              return <>{record?.mob_credit_status ? 
                <Tag color="green" className="tag-green" key={record.id}> {record?.status}   </Tag> :
                <Tag color="red" className="tag-red" key={record.id}> {record?.status} </Tag>
              }</>;
            },
    },
    {
      title: "Current Limit",
      dataIndex: "current_limit",
      key: "current_limit",
      width: "150px",
      render: (value) => `₹ ${value}`,
    },
    {
      title: "Any Rupifi (Others) Active/ Inactive account",
      dataIndex: "rupifi_status",
      key: "rupifi_status",
      width: "300px",
    },
    {
      title: "mobCREDIT Blocked (Default)",
      dataIndex: "mob_credit_status",
      key: "mob_credit_status",
      width: "200px",
      render: (parmas, record) => {
        return (
          <Col>
            <Text>{parmas}</Text>
          </Col>
        );
      },
    },
    
  ];
  return (
    <Col className="customer-container">
      <Text className="customer_title">mobCREDIT Direct</Text>
      <CustomerHeader
        handleAddCustomer={handleAddCustomer}
        getAllCustomersApi={getAllCustomersApi}
        isFetching={isFetching}
        // downloadCustomersApi={downloadCustomersApi}
        handleSearchedValue={handleSearchedValue}
      />
      <CustomTableWithPagination
        className="order-list-table"
        //   tableExpandable={defaultExpandable}
        //   tableDataSource={tableDataSource || []}
        tableDataSource={tableData?.data?.results}
        tableColumns={columns}
        locale={{
          emptyText: isFetching ? (
            <TableSkeleton length={10} />
          ) : (
            <NoDataFound text={"No customers found!"} />
          ),
        }}
        isLoading={tableData?.data?.results.length && isFetching}
        scroll={{ x: "100%" }}
        currentPage={currentPage}
        handlePageChange={handlePageChange}
        itemsPerPage={30}
        totalEntries={!isFetching && tableData?.data?.pagination?.total_entries}
      />
      
  
      {/* <ManageDeleteModal
        handleOk={handleDeleteModalCancel}
        open={isDeleteModalOpen}
        handleSave={onDelete}
        data={selectedRowData?.full_name}
      /> */}
    </Col>
  );
};

export default MOBcreditCustomer;
